import React from 'react';
import Slider from './Slider';
import PlantSticker from './PlantSticker';

const Blog = () => (
  <div className="div-home text-color-dark">
    <section className="section blog-heading-row">
      <PlantSticker className="blog-plant-sticker" />
      <h2 className="section-title">posts on medium ✍️</h2>
      <p className="section-subtitle">Android, AI, astronomy, and whatever else feels worth writing down</p>
      <Slider />
    </section>
  </div>
);

export default Blog;
